import { queryOptions } from '@tanstack/react-query';

import { keysToCamel } from '@shared/helpers';

import {
    deleteFinanceExportReportFunc,
    getFinanceExportReportsFunc,
    retryFinanceExportReportFunc,
} from './api-funcs';
import { FINANCE_EXPORT_REPORTS } from '../model/queryKeys';
import { IFinanceExportReport } from '../model/types';

export const financeExportReportApi = {
    getReportsQueryOptions: () =>
        queryOptions({
            queryKey: FINANCE_EXPORT_REPORTS,
            queryFn: (meta) => getFinanceExportReportsFunc({ signal: meta.signal }),
            select: (data) => keysToCamel<IFinanceExportReport[]>(data?.data?.data),
            refetchOnMount: true,
        }),
    deleteReport: (id: number) => deleteFinanceExportReportFunc(id),
    retryReport: (id: number) => retryFinanceExportReportFunc(id),
};
